import { useStateMachine } from 'little-state-machine';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import { ErrorMessageHandler, fileUploader } from '../../../../../_helpers/_methods';
import updateAction from './updateAction';
import { FormattedMessage } from 'react-intl';
import NavigationButtonGroup from '../../../../admin/Events/Steps/components/NavigationButtonGroup';

function OrganizationStep1() {
  const { actions } = useStateMachine({ updateAction });
  const navigate = useNavigate();
  const { id, edit: isEdit } = useParams();

  const [
    company_registration_document_resource_file_id,
    setCompany_registration_document_resource_file_id
  ] = useState([]);
  const [pan_registration_resource_file_id, setPan_registration_resource_file_id] = useState([]);

  const [other_resource_file_id, setOther_resource_file_id] = useState([]);

  const handleFileUpload = async (e, fileType) => {
    try {
      let response = await fileUploader(e.target.files, fileType);
      if (e.target.name === 'company_registration_document') {
        setCompany_registration_document_resource_file_id(response.ids[0]);
      }
      if (e.target.name === 'pan_registration_document')
        setPan_registration_resource_file_id(response.ids[0]);
      if (e.target.name === 'other_document') {
        setOther_resource_file_id(response.ids);
      }
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };
  const {
    register,
    handleSubmit,
    // setValue,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });

  const location = useLocation();
  const onSubmit = (data) => {
    data = {
      ...data,
      pan_registration_resource_file: pan_registration_resource_file_id,
      company_registration_document_resource_file: company_registration_document_resource_file_id,
      other_resource_file: other_resource_file_id
    };
    actions.updateAction(data);
    let path = location.pathname.split('/');

    if (isEdit) {
      navigate(`/admin/rosters/organization/${id}/edit/2`);
    } else {
      path.includes('admin')
        ? navigate('/admin/rosters/organization_apply/2')
        : navigate('/rosters/organization_apply/2');
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="">
          <h3 className="mt-4">
            <FormattedMessage id="documents" />
          </h3>

          <div className="row px-3">
            <h5 className="mb-2  d-inline">
              <FormattedMessage id="select_file" />
              <span className="text-danger">
                &nbsp;(
                <FormattedMessage id="file_format" />)
              </span>
            </h5>

            <div className="col-md-4">
              <FormGroup
                id="company_registration_document"
                label={<FormattedMessage id="company_registration_upload" />}
                type="file"
                acceptedFormats={['application/pdf', 'image/jpg', 'image/png']}
                register={register}
                error={errors}
                errorId={`company_registration_document`}
                required={isEdit ? false : true}
                onChange={(e) => handleFileUpload(e, 'company_registration_document')}
              />
            </div>
            <div className="col-md-4">
              <FormGroup
                errorId={`pan_registration_document`}
                id="pan_registration_document"
                label={<FormattedMessage id="pan_card_registration_upload" />}
                type="file"
                acceptedFormats={['application/pdf', 'image/jpg', 'image/png']}
                register={register}
                onChange={(e) => handleFileUpload(e, 'pan_registration_document')}
                error={errors}
                required={isEdit ? false : true}
              />
            </div>
            <div className="col-md-4">
              <FormGroup
                id="other_document"
                label={<FormattedMessage id="other_document_upload" />}
                type="file"
                acceptedFormats={['application/pdf', 'image/jpg', 'image/png']}
                register={register}
                onChange={(e) => handleFileUpload(e, 'other_document')}
                errorId={`other_document`}
                error={errors}
                isMulti={true}
                required={isEdit ? false : true}
              />
            </div>
          </div>
        </div>

        <div className="">
          <hr />
          <NavigationButtonGroup
          // showSubmit={id}
          />
        </div>
      </form>
    </div>
  );
}

export default OrganizationStep1;
